<template>
  <div>
    <component
      :is="type"
      v-bind="meta"
      :isDialog="isDialog"
      :code="meta.code || meta.id"
      :configH="isHeight"
      :layout="layout"
      :labelWidth="labelWidth|| 120"
      :meta="meta"
      :initCheckboxVal="initCheckboxVal"
    ></component>
  </div>
</template>
<script>
  import { getConfig } from '@/api/common.js'
  import { starOutRequestLoading as starLoading, closeOutRequestLoading as closeLoading } from '@/utils/loading.js'

  import report from '@/views/report/index.vue'
  import form from '@/views/baseForm/index.vue'
  import dragForm from '@/views/dragForm/index.vue'
  import dashboard from '@/views/newdashboard/index.vue'
  export default {
    name: 'fe-common',
    props: {
      initCheckboxVal: {
        type: Array
      },
      path: {
        type: String
      },
      isHeight: {
        type: String
      },
      isDialog: {
        required: false
      },
      tab: {
        type: String
      }
    },
    components: {
      'report': report,
      'base-form': form,
      'drag-form': dragForm,
      'dashboard': dashboard
    },
    data() {
      return {
        type: '',
        labelWidth: 120,
        meta: {},
        layout: {},
        configPath: ''
      }
    },
    watch: {
      path: {
        handler(val) {
          if (this.$route.path.indexOf('/config') === 0) {
            this.configPath = val
          }
        },
        deep: true,
        immediate: true
      },
      tab: {
        handler(val) {
          if (this.$route.path.indexOf('/tab') === 0) {
            this.getConfigByPath(val)
          }
        },
        deep: true,
        immediate: true
      }
    },
    mounted() {
      this.getConfigByPath(this.configPath)
    },
    methods: {
      getConfigByPath(path) {
        starLoading()
        const params = { noLoading: true }
        getConfig(path, params).then(res => {
          this.type = res.data.meta.type ? res.data.meta.type : 'report'
          this.layout = res.data.layout
          this.meta = res.data.meta
          this.labelWidth = this.meta.labelWidth || 120
          this.$emit('input', this.meta)
        }).catch(() => {
          closeLoading()
        })
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/config/index.vue